import { LoadingButton } from '@mui/lab'
import { Box, InputLabel, TextField } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

const KybIgnoreRiskMatrixReason = ({ onSubmit, isLoading }) => {
  const { t } = useTranslation(['common', 'messages'])
  const [ignoreReasonText, setIgnoreReasonText] = useState('')

  return (
    <>
      <Box className="modal-box">
        <InputLabel>{t('messages:kyb.ignoreRiskMatrixReason')}:</InputLabel>
        <TextField
          multiline
          placeholder={t('messages:minCharacters')}
          required
          onChange={(e) => setIgnoreReasonText(e.target.value)}
        />
      </Box>
      <Box className="modal-button">
        <LoadingButton
          size="small"
          color="secondary"
          variant="contained"
          loading={isLoading}
          disabled={ignoreReasonText.length < 5}
          onClick={() => onSubmit(ignoreReasonText)}
        >
          {t('common:kyb.ignoreRisk')}
        </LoadingButton>
      </Box>
    </>
  )
}

export default KybIgnoreRiskMatrixReason
